var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 8.93594V10.9359C11.3333 13.6026 10.2666 14.6693 7.59992 14.6693H5.06659C2.39992 14.6693 1.33325 13.6026 1.33325 10.9359V8.4026C1.33325 5.73594 2.39992 4.66927 5.06659 4.66927H7.06659M11.3333 8.93594H9.19992C7.59992 8.93594 7.06659 8.4026 7.06659 6.8026V4.66927M11.3333 8.93594L7.06659 4.66927M7.73325 1.33594H10.3999M4.66659 3.33594C4.66659 2.22927 5.55992 1.33594 6.66659 1.33594H8.41325M14.6666 5.33594V9.4626C14.6666 10.4959 13.8266 11.3359 12.7933 11.3359M14.6666 5.33594H12.6666C11.1666 5.33594 10.6666 4.83594 10.6666 3.33594V1.33594L14.6666 5.33594Z",
    stroke: "#D9D9D9",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.742d23867ec4d11f66fedfc8ec35fb77.svg";
export { ForwardRef as ReactComponent };